import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="design-iconfont"
    >
      <path
        d="M19.1876007,11.2230713 L6.77584579,11.2230713 L11.9026721,6.32544881 C12.2190989,6.02316836 12.2190989,5.52899078 11.9026721,5.22671033 C11.5862452,4.92442989 11.0689406,4.92442989 10.7525137,5.22671033 L4.23732015,11.4506308 C3.92089328,11.7529112 3.92089328,12.2470888 4.23732015,12.5493692 L10.7525137,18.7732897 C11.0689406,19.0755701 11.5862452,19.0755701 11.9026721,18.7732897 C12.2190989,18.4710092 12.2190989,17.9768316 11.9026721,17.6745512 L6.77584579,12.7752305 L19.1876007,12.7752305 C19.6355758,12.7752305 20,12.4254003 20,11.9991509 C20,11.5712033 19.6337981,11.2230713 19.1876007,11.2230713 Z"
        fill={color}
        fill-rule="nonzero"
      />
    </svg>
  )
}

const LeftArrow1Icon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default LeftArrow1Icon
